export interface EncyclopediaCard {
  id: string;
  category: string;
  title: string;
  summary: string;
  warningSigns: string[];
  defense: string[];
  unlocked: boolean;
}

export const ENCYCLOPEDIA_CARDS: EncyclopediaCard[] = [
  {
    id: 'phishing',
    category: 'Атаки',
    title: 'Фишинг',
    summary: 'Поддельные сайты копируют настоящие чтобы украсть логины, пароли и seed-фразы.',
    warningSigns: [
      'Адрес отличается на 1-2 буквы',
      'Нет замка в адресной строке',
      'Срочность и давление',
    ],
    defense: [
      'Проверяй URL перед вводом данных',
      'Используй bookmarks вместо ссылок',
      'Не переходи по ссылкам из сообщений',
    ],
    unlocked: true,
  },
  {
    id: 'fake_support',
    category: 'Мошенничество',
    title: 'Фальшивая поддержка',
    summary: 'Мошенники притворяются сотрудниками бирж, кошельков или техподдержки.',
    warningSigns: [
      'Просят seed-фразу или пароль',
      'Пишут первыми в Telegram',
      'Обещают быстро решить проблему',
    ],
    defense: [
      'Настоящая поддержка НИКОГДА не просит seed-фразу',
      'Обращайся только через официальный сайт',
      'Проверяй через другой канал',
    ],
    unlocked: true,
  },
  {
    id: 'seed_phrase',
    category: 'Безопасность',
    title: 'Кража seed-фразы',
    summary: 'Seed-фраза = ключ от всех твоих денег. Кто её знает — владеет кошельком.',
    warningSigns: [
      'Просят "ввести seed для проверки"',
      'Просят "ввести seed для аirdrop"',
      'Просят "ввести seed для миграции"',
    ],
    defense: [
      'Храни seed на бумаге, не в телефоне',
      'Никому не сообщай seed-фразу',
      'Используй hardware wallet для больших сумм',
    ],
    unlocked: true,
  },
  {
    id: 'guaranteed',
    category: 'Схемы',
    title: 'Гарантированная доходность',
    summary: 'Обещания фиксированной прибыли без рисков — это всегда скам.',
    warningSigns: [
      '"10% в день гарантированно"',
      '"Без рисков, только рост"',
      '"Инвестируй сейчас — завтра дороже"',
    ],
    defense: [
      'Рынок не даёт гарантий',
      'Высокий доход = высокий риск',
      'Любые "гарантии" — красный флаг',
    ],
    unlocked: true,
  },
  {
    id: 'pump_dump',
    category: 'Манипуляции',
    title: 'Pump & Dump',
    summary: 'Искусственный разгон цены токена через хайп, затем массовая продажа.',
    warningSigns: [
      'Резкий рост цены без новостей',
      '"Токен вырастет в 100 раз"',
      'Активный хайп в Telegram/Twitter',
    ],
    defense: [
      'DYOR — Do Your Own Research',
      'Не покупай на пике хайпа',
      'Проверяй кто владеет большим % токена',
    ],
    unlocked: true,
  },
];

export function getUnlockedCards(): string[] {
  try {
    const data = localStorage.getItem('hamsters_encyclopedia');
    return data ? JSON.parse(data) : ['phishing', 'fake_support', 'seed_phrase', 'guaranteed', 'pump_dump'];
  } catch {
    return ['phishing', 'fake_support', 'seed_phrase', 'guaranteed', 'pump_dump'];
  }
}

export function unlockCard(id: string): void {
  const cards = getUnlockedCards();
  if (!cards.includes(id)) {
    cards.push(id);
    localStorage.setItem('hamsters_encyclopedia', JSON.stringify(cards));
  }
}
